import { arrayToNull, emptyToNull } from '../../utils/form';
import type { SectionContextValidated, SectionContextValues } from './section-context-schema';
import type { CompanyPaymentOnAccount, FullCompanyContext } from './types/company';

/** Any API response carrying the shared section-context fields (company or section). */
type SectionContextSource = Partial<FullCompanyContext> & {
  name?: string | null;
  external_id?: string | null;
  integration_id?: string | null;
};

/** Map an API response's shared section-context fields onto the form's editable state. */
export function sectionContextToFormValues(source: SectionContextSource): SectionContextValues {
  const poc = source.payment_on_account ?? undefined;

  return {
    name: source.name ?? '',
    external_id: source.external_id ?? '',
    integration_id: source.integration_id ?? '',
    accounting_id: source.accounting_id ?? '',
    customer_group: source.customer_group ?? '',
    price_lists: source.price_lists ?? [],
    sales_agent_groups: source.sales_agent_groups ?? [],
    payment_on_account_enabled: !!poc,
    payment_on_account: {
      credit_limit: poc?.credit_limit != null ? String(poc.credit_limit) : '',
      balance: poc?.balance != null ? String(poc.balance) : '',
      currency_code: poc?.currency_code ?? '',
      net_terms: poc?.net_terms ?? '',
    },
  };
}

/** Map the shared, validated section-context fields onto their API request shape. */
export function buildSectionContextRequest(values: SectionContextValidated) {
  let payment_on_account: CompanyPaymentOnAccount | null = null;

  if (values.payment_on_account_enabled) {
    payment_on_account = {
      credit_limit: values.payment_on_account.credit_limit ?? null,
      balance: values.payment_on_account.balance ?? null,
      currency_code: emptyToNull(values.payment_on_account.currency_code),
      net_terms:
        values.payment_on_account.net_terms === '' ? null : values.payment_on_account.net_terms,
    };
  }

  return {
    name: values.name.trim(),
    external_id: emptyToNull(values.external_id),
    integration_id: emptyToNull(values.integration_id),
    accounting_id: emptyToNull(values.accounting_id),
    customer_group: emptyToNull(values.customer_group),
    price_lists: arrayToNull(values.price_lists),
    sales_agent_groups: arrayToNull(values.sales_agent_groups),
    payment_on_account,
  };
}
